import { BodyLong, Content, Heading, VerticalSpace } from '@elhub/ds-components'

import TopContainer from 'components/TopContainer/TopContainer'

import React from 'react'
import { useTranslation } from 'react-i18next'

import { LabelMessages } from '../locales/messages/label'

const Home = () => {
  const { t } = useTranslation()
  return (
    <TopContainer>
      <Content style={{ maxWidth: '1200px' }}>
        <Heading size='large' spacing>
          {t(LabelMessages.TERMS_OF_USE)}
        </Heading>
        <VerticalSpace size='2' />

        <BodyLong>
          Elhub is a company that provides a valuable service to the energy market in Norway. One way to do
          that is by allowing data access to private persons and companies for the betterment of any energy
          services.
        </BodyLong>
        <VerticalSpace />

        <BodyLong>
          We can do that if we can maintain our API access stable and accessible for everyone. Therefore, we
          need to set up API call limits in order to make sure the API service is not denied to other clients.
          This is a requirement that is common among all open and closed APIs available.
        </BodyLong>
        <VerticalSpace size='2' />

        <Heading spacing>Privacy</Heading>
        <VerticalSpace size='2' />

        <BodyLong>
          We require you and/or your company to register with us so you can be given API keys to access our
          REST APIs. The data we collect will be used solely for that purpose, and we will not share with
          anyone outside Elhub / Statnett, nor we will use it for any marketing purposes.
        </BodyLong>
        <VerticalSpace />
        <BodyLong>
          In a nutshell, we will not use your personal data for anything else than just controlling access
          from you and/or your applications to our API endpoints, to ensure everyone has the same stable
          access to them.
        </BodyLong>
        <VerticalSpace size='2' />

        <Heading spacing>Purpose and right of termination</Heading>
        <VerticalSpace size='2' />
        <BodyLong>
          The purpose of API access is to share public data to everyone that wants to use that data for
          personal and commercial purposes, as long as those purposes and intentions are not to hurt or impact
          negatively the community. Elhub reserves the right to deny access to the API, and / or terminate the
          account to anyone who is suspected to abuse the API service or intends to use the data for malicious
          purposes.
        </BodyLong>
      </Content>
    </TopContainer>
  )
}

export default Home
